module.exports = __webpack_public_path__ + "static/media/Siren.82dc886f.mp3";